import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { motion, useAnimation } from 'framer-motion';
import { useAnimationContext } from './AnimationContext';

const SectionAnimation = ({ children, delay = 0, initialLoad = false, sectionId }) => {
  const controls = useAnimation();
  const { activeSection, setActiveSection } = useAnimationContext();
  const isMobile = window.innerWidth <= 768;
  const [ref, inView] = useInView({
    threshold: isMobile ? 0.1 : 0.3,
    triggerOnce: isMobile,
    rootMargin: isMobile ? '-50px 0px' : '-100px 0px'
  });

  useEffect(() => {
    const animate = async () => {
      if (inView) {
        setActiveSection(sectionId);
        await controls.start({
          opacity: 1,
          y: 0,
          transition: {
            duration: isMobile ? 0.1 : 0.8,
            delay: 0,
            ease: isMobile ? "linear" : "easeOut"
          }
        });
      } else if (!isMobile) {
        await controls.start({
          opacity: 0,
          y: 30,
          transition: {
            duration: 0.5,
            ease: "easeIn",
            delay: 0
          }
        });
      }
    };

    animate();
  }, [controls, inView, delay, sectionId, setActiveSection, isMobile]);

  useEffect(() => {
    if (!isMobile && activeSection !== sectionId && !inView) {
      controls.start({
        opacity: 0,
        y: 30,
        transition: {
          duration: 0.5,
          ease: "easeIn",
          delay: 0
        }
      });
    }
  }, [activeSection, sectionId, controls, inView, isMobile]);

  const initialAnimation = initialLoad ? {
    initial: { opacity: 0, y: 30 },
    animate: controls
  } : {};

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: isMobile ? 10 : 30 }}
      animate={controls}
      {...initialAnimation}
      style={{ 
        willChange: 'opacity, transform',
        minHeight: '100px',
        position: 'relative',
        zIndex: 1
      }}
    >
      {children}
    </motion.div>
  );
};

export default SectionAnimation;
